import { createSlice } from '@reduxjs/toolkit';
import { ConnectivityCameraReportModel, ConnectivityCameraReportResultModel } from "../../@types/connectivity";
import { dispatch } from '../store';
import { AxiosResponseModel } from '../../@types/base';
import axios from '../../utils/axios';
import { CONSTS } from './const';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';

type ConnectivityState = {
  connectivityCameraReportError: boolean;
  isConnectivityCameraReportLoading: boolean;
  connectivityCameraReportList: ConnectivityCameraReportModel | null;
};

const initialState: ConnectivityState = {
  connectivityCameraReportError: false,
  isConnectivityCameraReportLoading: true,
  connectivityCameraReportList: null
};

const slice = createSlice({
  name: 'connectivity',
  initialState,
  reducers: {
    startConnectivityLoading(state) {
      state.isConnectivityCameraReportLoading = true;
    },

    hasErrorConnectivity(state, action) {
      state.isConnectivityCameraReportLoading = false;
      state.connectivityCameraReportError = action.payload;
    },

    getConnectivitySuccess(state, action) {
      state.isConnectivityCameraReportLoading = false;
      state.connectivityCameraReportList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export async function getConnectivityCameraReport(
  startDate: string,
  endDate: string,
  cameraId: string | null
) {
  dispatch(slice.actions.startConnectivityLoading());
  try {
    if (startDate.includes('T')) {
      startDate = startDate.slice(0, startDate.indexOf('T'));
    }
    if (endDate.includes('T')) {
      endDate = endDate.slice(0, endDate.indexOf('T'));
    }
    let str = `${CONSTS.CONSTANTS_GET_GET_CAMERA_CONNECTION_REPORT}?startDate=${startDate}&endDate=${endDate}`;
    if (cameraId) {
      str = `${CONSTS.CONSTANTS_GET_GET_CAMERA_CONNECTION_REPORT}?startDate=${startDate}&endDate=${endDate}&cameraId=${cameraId}`;
    }
    const response: AxiosResponseModel<ConnectivityCameraReportResultModel> = await axios
      .get(str)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.hasErrorConnectivity(null));
      dispatch(slice.actions.getConnectivitySuccess(response.data?.data));

    } else {
      dispatch(slice.actions.getConnectivitySuccess(null));
    }
    return response
  } catch (error: any) {
    dispatch(slice.actions.getConnectivitySuccess(null));
    dispatch(slice.actions.hasErrorConnectivity(error));
    return error.response.data;
  }
}
